import React from 'react';
import CrossRoad from "../UI/Crossroad";
import { tracksColors } from "../../config/styles";

const CrossRoad_12CRed_12DRed = () => <CrossRoad coords="2184.000000, 414.000000" color={tracksColors.red}/>;
export default CrossRoad_12CRed_12DRed;
